import { useState } from 'react';
import { Close } from '@mui/icons-material';
import { TagContainer, RemoveButton } from './PargodaTag.styles';
import { ITag } from '../../../../common';

interface PargodaTagProps {
    tag: ITag;
    onRemove?: (tagId: number) => void;
}

const PargodaTag: React.FC<PargodaTagProps> = ({ tag, onRemove }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onRemove) {
            onRemove(tag.id);
        }
    };

    const hexToRgba = (hex: string | null | undefined, opacity: number) => {
        if (!hex) return 'transparent';
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    return (
        <TagContainer
            style={{ backgroundColor: hexToRgba(tag.color, 0.3) }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {tag.label}
            {onRemove && (
                <RemoveButton className="remove-button" onClick={handleRemove}>
                    <Close sx={{ fontSize: 16 }} />
                </RemoveButton>
            )}
        </TagContainer>
    );
};

export default PargodaTag;
